import React from "react";
import { Helmet } from 'react-helmet-async';
import NavbarContainer from "./navbar/navbar_container";
import PhotoshootsIndex from "./projects_index/admin_photoshoots";

const ProjectsIndex = ({currentUser}) => (
  <div className="dashboardFullPageDiv">
    <Helmet><title>Photoshoots</title></Helmet>
    <div className="projectsIndexPageGroupings adminPhotoshootsShell">
      <NavbarContainer/>
      <div className="dashboardMainDiv adminPhotoshootsPage" id="projectsIndexMainDiv">
        <PhotoshootsIndex key={currentUser.id} currentUser={currentUser}/>
      </div>
    </div>
  </div>
);

export default ProjectsIndex;
